import React from "react";
import PropTypes from "prop-types";
import { Button, useMediaQuery } from "@mui/material";
import json2mq from "json2mq";
import { shortQueries } from "../queries";

export const GoodBadEstimationsTour = (props) => {
  const short = useMediaQuery(json2mq(shortQueries));

  const textStyle = {
    fontFamily: "'Open Sans', sans-serif",
    fontSize: short ? 14 : 16,
  };

  return (
    <div style={textStyle}>
      <img
        src="/Measureit-logo.png"
        alt="measureit-welcome"
        style={{ height: 40 }}
      />
      {false ? null : (
        <img
          src="/mobilerightwrong2.png"
          alt="good bad examples"
          style={{ width: "100%" }}
        />
      )}
      <Button variant="contained" sx={{ float: "right" }} onClick={() => props.closeTour(false)}>
        Start Estimating
      </Button>
    </div>
  );
};

GoodBadEstimationsTour.propTypes = {
  closeTour: PropTypes.func.isRequired,
};
